<template>
  <div>
    <v-menu
      v-if="
        (hasRole('companyGroup', 'ROLE_PUT_COMPANYGROUP') && routeName === 'CompanyDetail') ||
        (routeName === 'Company' && (hasRole('profiles', 'ROLE_ADMINISTRATOR') || hasRole('profiles', 'ROLE_FINANCIAL_ADMIN'))) ||
        (routeName === 'Company' && hasRole('company', 'ROLE_PUT_COMPANY_ID_DISABLE')) ||
        (hasRole('company', 'ROLE_PUT_COMPANY_ENABLEALLEMPLOYEE_V2PERMISSION')) ||
        (hasRole('employee', 'ROLE_GET_EMPLOYEE_EXPORT') || hasRole('costCenter', 'ROLE_GET_COSTCENTER_EXPORT') || hasRole('project', 'ROLE_GET_PROJECT_EXPORT'))
      "
      v-model="visible"
      :left="routeName === 'CompanyDetail'"
      offset-y
    >
      <button v-if="routeName === 'Company'" class="table-body__actions" slot="activator">
        <v-icon>more_vertical</v-icon>
      </button>

      <button
        v-if="routeName === 'CompanyDetail'"
        class="dropdown-custom__activator mr-3"
        slot="activator"
        style="display: flex;"
      >
        <span class="toolbar__button-label accent--text">
          {{ $t(`${namespace}.moreActions`) }}
        </span>
        <v-icon class="hidden-xs-only autocomplete__arrow mx-0" color="accent" right small>
          keyboard_arrow_down
        </v-icon>
      </button>

      <v-list class="dropdown-menu-actions__list">
        <v-list-tile
          v-if="isAdminProfile && routeName === 'Company'"
          @click="handleCompanyEditInfo"
        >
          {{ $t(`${namespace}.companyEditInfo`) }}
        </v-list-tile>

        <v-list-tile
          v-if="hasRole('companyGroup', 'ROLE_PUT_COMPANYGROUP') && routeName === 'CompanyDetail'"
          @click="handleCompanyEditInfo"
        >
          {{ $t(`${namespace}.linkCompanyGroup`) }}
        </v-list-tile>

        <v-list-tile
          v-if="routeName === 'Company' && (hasRole('profiles', 'ROLE_ADMINISTRATOR') || hasRole('profiles', 'ROLE_FINANCIAL_ADMIN'))"
          @click="handleCompanyEditFinancialInfo"
        >
          {{ $t(`${namespace}.companyEditFinancialInfo`) }}
        </v-list-tile>

        <v-divider v-if="routeName === 'Company' && (hasRole('profiles', 'ROLE_ADMINISTRATOR') || hasRole('profiles', 'ROLE_FINANCIAL_ADMIN'))" />

        <v-list-tile
          v-if="routeName === 'Company' && hasRole('company', 'ROLE_PUT_COMPANY_ID_DISABLE')"
          @click="openChangeCompanyStatusDialog"
        >
          {{ $t(`${namespace}.changeStatus`) }}
        </v-list-tile>

        <v-list-tile
          v-if="hasRole('company', 'ROLE_PUT_COMPANY_ENABLEALLEMPLOYEE_V2PERMISSION')"
          @click="openAllowEmployeeAccessDialog"
        >
          {{ $t(`${namespace}.allowEmployeesAccess`) }}
        </v-list-tile>

        <v-divider v-if="hasRole('employee', 'ROLE_GET_EMPLOYEE_EXPORT') || hasRole('costCenter', 'ROLE_GET_COSTCENTER_EXPORT') || hasRole('project', 'ROLE_GET_PROJECT_EXPORT')" />

        <v-menu class="v-menu__inside" offset-x open-on-hover full-width>
          <v-list-tile
            v-if="hasRole('employee', 'ROLE_GET_EMPLOYEE_EXPORT') || hasRole('costCenter', 'ROLE_GET_COSTCENTER_EXPORT') || hasRole('project', 'ROLE_GET_PROJECT_EXPORT')"
            slot="activator"
            @click="() => {}"
          >
            <v-list-tile-title>
              {{ $t(`${namespace}.export`) }}
            </v-list-tile-title>

            <v-list-tile-action class="justify-end">
              <v-icon>keyboard_arrow_right</v-icon>
            </v-list-tile-action>
          </v-list-tile>

          <v-list class="dropdown-menu-actions__list">
            <v-list-tile
              :disabled="isExporting"
              v-if="hasRole('employee', 'ROLE_GET_EMPLOYEE_EXPORT')"
              @click="handleExportEmployees"
            >
              {{ $t(`${namespace}.exportEmployees`) }}
            </v-list-tile>

            <v-list-tile
              :disabled="isExporting"
              v-if="hasRole('costCenter', 'ROLE_GET_COSTCENTER_EXPORT')"
              @click="handleExportCostCenters"
            >
              {{ $t(`${namespace}.exportCostCenters`) }}
            </v-list-tile>

            <v-list-tile
              :disabled="isExporting"
              v-if="hasRole('project', 'ROLE_GET_PROJECT_EXPORT')"
              @click="handleExportProjects"
            >
              {{ $t(`${namespace}.exportProjects`) }}
            </v-list-tile>

            <v-list-tile v-if="false" @click="handleExportAccounts">
              <code class="mr-2">BACKLOG</code> {{ $t(`${namespace}.exportAccounts`) }}
            </v-list-tile>
          </v-list>
        </v-menu>

        <v-menu class="v-menu__inside" offset-x open-on-hover full-width>
          <v-list-tile
            v-if="hasRole('company', 'ROLE_POST_COMPANY_ID_EMPLOYEE_BATCHUPDATE') || hasRole('company', 'ROLE_POST_COMPANY_ID_COSTCENTER_UPLOAD')"
            slot="activator"
            @click="() => {}"
          >
            <v-list-tile-title>
              {{ $t(`${namespace}.import`) }}
            </v-list-tile-title>

            <v-list-tile-action class="justify-end">
              <v-icon>keyboard_arrow_right</v-icon>
            </v-list-tile-action>
          </v-list-tile>

          <v-list class="dropdown-menu-actions__list">
            <v-list-tile
              v-if="hasRole('company', 'ROLE_POST_COMPANY_ID_EMPLOYEE_BATCHUPDATE')"
              @click="handleAddUpdateEmployeesBulk"
            >
              {{ $t(`${namespace}.addUpdateEmployeesBulk`) }}
            </v-list-tile>

            <v-list-tile
              v-if="hasRole('company', 'ROLE_POST_COMPANY_ID_COSTCENTER_UPLOAD')"
              @click="handleImportCostCenters"
            >
              {{ $t(`${namespace}.importCostCenters`) }}
            </v-list-tile>

            <v-list-tile @click="handleImportProjects">
              {{ $t(`${namespace}.importProjects`) }}
            </v-list-tile>
          </v-list>
        </v-menu>

        <v-menu v-if="false" class="v-menu__inside" offset-x open-on-hover full-width>
          <v-list-tile slot="activator" @click="() => {}">
            <v-list-tile-title>
              <code class="mr-2">???????</code> {{ $t(`${namespace}.callAcarPermission`) }}
            </v-list-tile-title>
            <v-list-tile-action class="justify-end">
              <v-icon>keyboard_arrow_right</v-icon>
            </v-list-tile-action>
          </v-list-tile>

          <v-list class="dropdown-menu-actions__list">
            <v-list-tile @click="() => {}">
              <code class="mr-2">???????</code> {{ $t(`${namespace}.allowWebcallForAllEmployees`) }}
            </v-list-tile>

            <v-list-tile @click="() => {}">
              <code class="mr-2">???????</code> {{ $t(`${namespace}.denyWebcallForAllEmployees`) }}
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-list>
    </v-menu>

    <ChangeCompanyStatusDialog
      :visible="changeCompanyStatusDialog"
      :company="company"
      @close="closeChangeCompanyStatusDialog"
    />

    <AllowEmployeeAccessDialog
      :visible="allowEmployeeAccessDialog"
      :company="company"
      @close="closeAllowEmployeeAccessDialog"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { hasRole } from 'utils/functions'
import { exportAsync } from 'utils/exportAsync'
import ChangeCompanyStatusDialog from 'components/company/ChangeCompanyStatusDialog'
import AllowEmployeeAccessDialog from 'components/company/AllowEmployeeAccessDialog'

export default {
  name: 'CompanyMenuActions',
  props: {
    company: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ChangeCompanyStatusDialog,
    AllowEmployeeAccessDialog
  },
  computed: {
    ...mapState({
      isAdminProfile: state => {
        return state.session.user.business.isAdministrator ||
          state.userClaims.claims.profiles['ROLE_ADMINISTRATOR'] ||
          state.userClaims.claims.profiles['ROLE_FINANCIAL_ADMIN']
      }
    }),

    routeName () {
      return this.$route.name
    },

    companyTargetId () {
      const routeId = this.$route.params && this.$route.params.id
        ? this.$route.params.id
        : null
      const companyId = this.company && this.company.id
        ? this.company.id
        : null
      return routeId || companyId
    }
  },
  data () {
    return {
      namespace: 'Components.CompanyMenuActions',
      visible: false,
      changeCompanyStatusDialog: false,
      allowEmployeeAccessDialog: false,
      downState: {
        downloadCsvAutoRequest: undefined,
        downloadCsvPercentage: 0
      },
      isExporting: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show',
      successAlert: 'snackbarAlert/success'
    }),

    hasRole (group, role) {
      return hasRole(group, role)
    },

    closeMenu () {
      this.visible = false
    },

    openChangeCompanyStatusDialog () {
      this.changeCompanyStatusDialog = true
    },

    closeChangeCompanyStatusDialog (reload) {
      this.changeCompanyStatusDialog = false
      reload && this.$emit('reload')
    },

    openAllowEmployeeAccessDialog () {
      this.allowEmployeeAccessDialog = true
    },

    closeAllowEmployeeAccessDialog () {
      this.allowEmployeeAccessDialog = false
    },

    handleCompanyEditInfo () {
      if (this.routeName === 'CompanyDetail') {
        return this.$router.push({
          name: 'EditCompany',
          params: { id: this.company.id },
          query: { companyGroup: 'focus' }
        })
      }

      this.$router.push({
        name: 'EditCompany',
        params: { id: this.company.id }
      })
    },

    handleCompanyEditFinancialInfo () {
      this.$router.push({
        name: 'CompanyFinancialConfig',
        params: { id: this.company.id }
      })
    },

    onExportAsyncSuccess (msg) {
      return () => {
        this.successAlert(msg || this.$t(`Common.successExport`))
        this.isExporting = false
      }
    },

    onExportAsyncError (msg) {
      return () => {
        this.showAlert({
          type: 'error',
          message: msg || this.$t('Common.errorExport')
        })
        this.isExporting = false
      }
    },

    async handleExportEmployees () {
      try {
        if (!this.company || !this.company.id) {
          throw new Error()
        }

        this.closeMenu()
        this.isExporting = true
        exportAsync(
          { companyId: this.company.id, search: this.search, type: 'configEmployee' },
          '99Empresas_colaboradores.csv',
          this.onExportAsyncSuccess(this.$t('Views.EmployeesPage.successExport')),
          this.onExportAsyncError(this.$t(`Views.EmployeesPage.errorExport`)),
          this.downState
        )
      } catch (err) {
        console.log('ERROR:', err)
      }
    },

    async handleExportCostCenters () {
      try {
        if (!this.company || !this.company.id) {
          throw new Error()
        }

        this.closeMenu()
        this.isExporting = true
        exportAsync(
          { companyId: this.company.id, search: this.search, type: 'configCostCenter' },
          '99Empresas_centrosDeCusto.csv',
          this.onExportAsyncSuccess(this.$t('Views.CostCenterPage.successExport')),
          this.onExportAsyncError(this.$t(`Views.CostCenterPage.errorExport`)),
          this.downState
        )
      } catch (err) {
        console.log('ERROR:', err)
      }
    },

    async handleExportProjects () {
      try {
        if (!this.company || !this.company.id) {
          throw new Error()
        }
        this.closeMenu()
        this.isExporting = true
        exportAsync(
          { companyId: this.company.id, search: this.search, type: 'configProject' },
          '99Empresas_projetos.csv',
          this.onExportAsyncSuccess(this.$t('Views.ProjectsPage.successExport')),
          this.onExportAsyncError(this.$t(`Views.ProjectsPage.errorExport`)),
          this.downState
        )
      } catch (err) {
        console.log('ERROR:', err)
      }
    },

    handleExportAccounts () {
      alert('BACKLOG')
    },

    handleAddUpdateEmployeesBulk () {
      this.$router.push({
        name: 'EmployeeBulkOperation',
        params: { id: this.companyTargetId }
      })
    },

    handleImportCostCenters () {
      this.$router.push({
        name: 'CostCenterBulkOperation',
        params: { id: this.companyTargetId }
      })
    },

    handleImportProjects () {
      this.$router.push({
        name: 'ProjectBulkOperation',
        params: { id: this.companyTargetId }
      })
    }
  },
  destroyed () {
    // clearInterval(this.downState.downloadCsvAutoRequest)
  }
}
</script>

<style lang="scss" scoped>
.v-menu__inside {

  [role="listitem"] {
    width: 100%;
  }
}
</style>
